// Gate that hides protected routes until /api/auth/me has resolved.
// - 'unknown'   → centered loading spinner (the cookie check is in-flight).
// - 'unauthed'  → redirect to /login, preserving no return URL for now
//                  (Sprint 2 only has /, /settings — no deep links to preserve).
// - 'authed'    → render children.

import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import type { AuthState } from '../hooks/useAuth';
import { Spinner } from './atoms/Spinner';

export interface ProtectedRouteProps {
  authState: AuthState;
  children: ReactNode;
}

export function ProtectedRoute({ authState, children }: ProtectedRouteProps) {
  if (authState === 'unknown') {
    return (
      <div
        className="flex h-full w-full items-center justify-center bg-background"
        data-testid="auth-loading"
      >
        <Spinner size="lg" />
      </div>
    );
  }

  if (authState === 'unauthed') {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

